import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import styles from "../styles/Hero.module.css";

const SERVICES = [
  "Public Relations",
  "Research & Marketing",
  "UI/UX Planning",
  "SEO & AIO",
  "Digital Consulting",
  "Web Designing",
  "App Development",
  "Social Media Optimisation",
  "Google Ads (AdWords)",
  "Performance Analytics",
  "Branding",
  "Content Strategy",
];

const HOLD_MS = 2600; // time each word stays on screen
const REVEAL_EASE = [0.65, 0, 0.35, 1]; // smooth in-out wipe

const Hero = () => {
  const [index, setIndex] = useState(0);
  const reduce = useReducedMotion();

  useEffect(() => {
    const t = setInterval(
      () => setIndex((i) => (i + 1) % SERVICES.length),
      HOLD_MS
    );
    return () => clearInterval(t);
  }, []);

  const word = SERVICES[index];

  return (
    <div className={styles.heroContainer}>
      {/* Background */}
      <div className={styles.videoBackground}>
        <img
          className={styles.fallbackImage}
          src="/backgroundVideo.jpg"
          alt=""
          width={1920}
          height={1080}
          fetchPriority="high"
        />
        <video
          className={styles.video}
          src="/backgroundVideo.mp4"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        />
      </div>

      {/* Content */}
      <div className={styles.heroContent}>
        <h1 className={styles.heroTitle} data-aos="fade-up">
          <span className={styles.lead}>We build your brand through</span>

          <span className={styles.typedLine} aria-live="polite">
            {reduce ? (
              // Reduced motion: simple swap, no wipe
              <span className={styles.word}>{word}</span>
            ) : (
              <AnimatePresence mode="wait">
                <motion.span
                  key={word}
                  className={styles.word}
                  initial={{ clipPath: "inset(0 100% 0 0)" }}
                  animate={{ clipPath: "inset(0 0% 0 0)" }}
                  exit={{ clipPath: "inset(0 0 0 100%)" }}
                  transition={{ duration: 0.7, ease: REVEAL_EASE }}
                >
                  {word}
                </motion.span>
              </AnimatePresence>
            )}
          </span>
        </h1>

        {/* ===== Hero CTAs — comment out this whole block if not wanted ===== */}
        <div className={styles.ctaRow} data-aos="fade-up" data-aos-delay="150">
          <Link to="/contact" className={styles.ctaPrimary}>
            Get Started
          </Link>
          <Link to="/what-we-do" className={styles.ctaGhost}>
            Explore Services
          </Link>
        </div>
        {/* ===== end Hero CTAs ===== */}
      </div>
    </div>
  );
};

export default Hero;
